
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(376|380|568)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
